import Live from '../../api/http/models/Live'

export default {
  actions: {
    async fetchLiveToken (ctx) {
      const response = await Live.authToken(ctx.getters.authUserCompany.slug)
      if (response.data) {
        ctx.commit('updateToken', response.data.token)
        ctx.commit('updateExpiresAt', response.data.expires_at)
        ctx.commit('updateChannel', response.data.channel)
      }
    }
  },
  mutations: {
    updateToken (state, token) {
      state.token = token
    },
    updateExpiresAt (state, expires_at) {
      state.expires_at = expires_at
    },
    updateChannel (state, channel) {
      state.channel = channel
    }
  },
  state: {
    token: '',
    expires_at: '',
    channel: ''
  },
  getters: {
    liveToken (state) {
      return state.token
    },
    liveTokenExpiresAt (state) {
      return state.expires_at
    },
    liveChannel (state) {
      return state.channel
    }
  }
}
